import React from "react";

interface HomePageProps {
  onNavigate?: (tab: string) => void;
}

const HomePage: React.FC<HomePageProps> = ({ onNavigate }) => {
  const nav = (tab: string) => onNavigate && onNavigate(tab);
  return (
    <div style={styles.container}>
      <div style={styles.heroBox}>
        <h1 style={styles.title}>OMNI - AI based unstructured cataloging solution</h1>
        <p style={styles.subtitle}>
          Automatically extract, classify and catalog metadata from your documents using AI.
        </p>
      </div>

      <div style={styles.cardRow}>
        <div style={{ ...styles.card, cursor: 'pointer' }} onClick={() => nav('batch')}>
          <div style={styles.cardIcon}>🗂️</div>
          <h3 style={styles.cardTitle}>Batch Scan</h3>
          <p style={styles.cardText}>
            Scan and process multiple files at once from a folder automatically.
          </p>
        </div>

        <div style={{ ...styles.card, cursor: 'pointer' }} onClick={() => nav('manual')}>
          <div style={styles.cardIcon}>📄</div>
          <h3 style={styles.cardTitle}>Manual Upload</h3>
          <p style={styles.cardText}>
            Upload a single PDF file and extract metadata manually with AI assistance.
          </p>
        </div>

        <div style={{ ...styles.card, cursor: 'pointer' }} onClick={() => nav('telemetry')}>
          <div style={styles.cardIcon}>📊</div>
          <h3 style={styles.cardTitle}>Telemetry</h3>
          <p style={styles.cardText}>
            View usage metrics and processing activity across the solution.
          </p>
        </div>

        <div style={styles.card}>
          <div style={styles.cardIcon}>📥</div>
          <h3 style={styles.cardTitle}>Download Results</h3>
          <p style={styles.cardText}>
            Download extracted metadata as Excel files directly to your system.
          </p>
        </div>

        <div style={{ ...styles.card, cursor: 'not-allowed', opacity: 0.5 }} title="Coming soon">
          <div style={styles.cardIcon}>🚀</div>
          <h3 style={styles.cardTitle}>Upload to Alation</h3>
          <p style={styles.cardText}>
            Push extracted and reviewed metadata directly into Alation.
          </p>
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    maxWidth: 1100,
    margin: "0 auto",
    padding: 32,
  },
  heroBox: {
    textAlign: "center",
    padding: "48px 32px",
    background: "#fff",
    borderRadius: 12,
    marginBottom: 32,
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },
  title: {
    fontSize: 32,
    color: "#1565c0",
    marginBottom: 16,
  },
  subtitle: {
    fontSize: 16,
    color: "#666",
    maxWidth: 600,
    margin: "0 auto",
  },
  cardRow: {
    display: "flex",
    gap: 24,
    justifyContent: "center",
    flexWrap: "wrap",
  },
  card: {
    background: "#fff",
    borderRadius: 12,
    padding: 32,
    width: 280,
    textAlign: "center",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
    border: "1px solid #e0e0e0",
  },
  cardIcon: {
    fontSize: 48,
    marginBottom: 16,
  },
  cardTitle: {
    fontSize: 18,
    color: "#1565c0",
    marginBottom: 8,
  },
  cardText: {
    fontSize: 14,
    color: "#666",
    lineHeight: 1.6,
  },
};

export default HomePage;